<script>
  import SpeakersWithEventDescription from "../../Component/SpeakersWithEventDescription.svelte";

  export let item;
</script>

<SpeakersWithEventDescription {item} firstPersonIsModerator={false}>
  <svelte:fragment slot="headline">
    {#if item.typ == 4}Frühstücksworkshop{:else}Podiumsdiskussion{/if}: {item.eventTitle}
  </svelte:fragment>
  <svelte:fragment slot="date">
    {#if item.startDate}
      {new Date(item.startDate).toLocaleDateString("de-DE", { weekday: "long", month: "long", day: "2-digit" })}, {item.startTime}-{item.endTime} Uhr
    {/if}
  </svelte:fragment>
  <svelte:fragment slot="actions" />
</SpeakersWithEventDescription>
